<template>
	<div class="!border-0 !ring-0 !font-sans">
	<!-- 600px -->
	<v-card flat 
		:min-width="`${ this.$vuetify.breakpoint.smAndDown ? 'unset' : '800px' }`"
		style="border-bottom-left-radius: 0 !important; border-bottom-right-radius: 0 !important;"
		class="dark:!bg-csenBlue-900 !border-0 !ring-0"
	
		>
		<v-card-title class="font-bold text-2xl py-6 pl-8 dark:!bg-csenBlue-800 border-b border-b-gray-200 dark:border-none">
			<span class="font-bold">Filtri</span>
			<v-spacer></v-spacer>
			<v-btn class="!text-gray-900 dark:!text-csenBlue-200" icon @click="chiudiDialogFiltri">
                  <CloseIcon />
            </v-btn>

		</v-card-title>
		<v-card-text>

			<v-sheet
				outlined
				rounded
				class="mb-3 mt-4 pa-3 dark:!bg-csenBlue-900"
			>
				<div class="mb-2">Filtra per nome e/o cognome</div>
				<v-text-field
					label="Nome"
					v-model="filtri.nome"
					autocomplete="nope" 
					outlined
					dense
					:rules="[]"
					hide-details
					class="mb-3"
					clearable
					clear-icon="mdi-close-circle-outline"
				></v-text-field>

				<v-text-field
					label="Cognome"
					v-model="filtri.cognome"
					autocomplete="nope" 
					outlined
					dense
					:rules="[]"
					hide-details
					clearable
					clear-icon="mdi-close-circle-outline"
				></v-text-field>
			</v-sheet>

			<!-- style="border: thin solid rgba(255,255,255,.2);" -->
			<!-- style="border: thin solid rgba(0,0,0,.2);" -->
			<v-sheet
				outlined
				rounded
				class="mb-3 dark:!bg-csenBlue-900"
			>
				<div class="mt-3 mx-3">Filtra per zona geografica</div>
				<v-text-field
					v-model="localitaSearch"
					label="Cerca città o sigle di province"
					outlined
					dense
					hide-details
					clearable
					clear-icon="mdi-close-circle-outline"
					class="mt-2 mb-1 mx-3"
					autocomplete="nope"
					@input="espandiTutteLocalita"
				></v-text-field>
				<!-- :disabled="localita[0].children.length === 0" -->
				<v-treeview
					:items="localita"
					item-text="name"
    				item-key="name"
					:search="localitaSearch"
					:load-children="getProvinceComuni"
					v-model="filtri.comuniSelezionati"
					selected-color="primary"
					selectable
					open-on-click
					:open.sync="localitaAperte"
					dense
				>
				</v-treeview>
			</v-sheet>
			
			<v-sheet
				outlined
				rounded
				class="mb-3 dark:!bg-csenBlue-900"
			>
				<div class="mt-3 mx-3">Filtra per diploma</div>
				<v-text-field
					v-model="diplomaSearch"
					label="Cerca nomi di aree o diplomi"
					outlined
					dense
					hide-details
					clearable
					clear-icon="mdi-close-circle-outline"
					class="mt-2 mb-1 mx-3"
					autocomplete="nope"
					@input="espandiTuttiDiplomi"
				></v-text-field>
				<v-treeview
					:key="treeviewDiplomiKey"
					:items="diplomi"
					:search="diplomaSearch"
					v-model="filtri.diplomiSelezionatiKeys"
					item-text="name"
    				item-key="key"
					selected-color="primary"
					selectable
					open-on-click
					:open.sync="diplomiAperti"
					dense
				>

				<!-- v-if="!item.children && !item.loading"
				@click="loadChildren(item)" -->
					<template v-slot:label="{ item }">
						<span>{{ item.name }}</span>
						<v-btn v-if="item.hasEdizioni && !item.isEdizioniMostrate" @click="mostraEdizioniCorso(item)" small class="ml-4">
							Specifica edizioni
						</v-btn>
						<v-btn v-else-if="item.hasEdizioni && item.isEdizioniMostrate" @click="nascondiEdizioniCorso(item)" small class="ml-4">
							Ignora edizioni
						</v-btn>
					</template>

				</v-treeview>

				<v-radio-group 
					v-model="filtri.tipoFiltroDiplomi"
					row
					class="mx-4"
				>
					<v-radio
						label="Almeno uno tra i diplomi selezionati"
						value="or"
					></v-radio>
					<v-radio
						label="Tutti i diplomi selezionati"
						value="and"
					></v-radio>
				</v-radio-group>
				
				<div v-if="loggedAs && loggedAs.ruolo=='admin'">
					<div class="mb-1 mx-3">Data di conseguimento</div>
					<div class="d-flex mb-3 mx-3">
						<v-menu
							v-model="menuDataDal"
							:close-on-content-click="false"
							transition="scale-transition"
							offset-y
							max-width="290px"
							min-width="auto"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									label="Dal"
									v-model="computedDataDalFormattata"
									persistent-hint
									append-icon="mdi-calendar"
									readonly
									outlined
									dense
									v-bind="attrs"
									v-on="on"
									hide-details
									clearable
									clear-icon="mdi-close-circle-outline"
									class="mr-3"
								></v-text-field>
							</template>
							<v-date-picker
								v-model="filtri.dataDal"
								no-title
								@input="menuDataDal = false"
								locale="it-IT"
								max="2099-12-31"
								min="1900-12-31"
								:disabled="isDateDiplomiDisabled"
							></v-date-picker>
						</v-menu>

						<v-menu
							v-model="menuDataAl"
							:close-on-content-click="false"
							transition="scale-transition"
							offset-y
							max-width="290px"
							min-width="auto"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									label="Al"
									v-model="computedDataAlFormattata"
									persistent-hint
									append-icon="mdi-calendar"
									readonly
									outlined
									dense
									v-bind="attrs"
									v-on="on"
									hide-details
									clearable
									clear-icon="mdi-close-circle-outline"
								></v-text-field>
							</template>
							<v-date-picker
								v-model="filtri.dataAl"
								no-title
								@input="menuDataAl = false"
								locale="it-IT"
								max="2099-12-31"
								min="1900-12-31"
								:disabled="isDateDiplomiDisabled"
							></v-date-picker>
						</v-menu>
					</div>
				</div>
			</v-sheet>

			<v-sheet v-if="loggedAs && loggedAs.ruolo=='admin'" outlined rounded class="mb-3 dark:!bg-csenBlue-900">
				<div class="mt-3 mx-3">Tipo di contatto</div>
				<v-radio-group v-model="filtri.tipoContatto" row class="mx-4">
					<v-radio
						label="Tutti"
						value="all"
					></v-radio>
					<v-radio
						label="Solo con email"
						value="only_with_email"
					></v-radio>
					<v-radio
						label="Solo senza email"
						value="only_without_email"
					></v-radio>
					<v-radio
						label="Solo con telefono"
						value="only_with_phone"
					></v-radio>
					<v-radio
						label="Solo senza telefono"
						value="only_without_phone"
					></v-radio>
				</v-radio-group>
			</v-sheet>

			<v-sheet v-if="loggedAs && loggedAs.ruolo=='admin'" outlined rounded class="mb-3 dark:!bg-csenBlue-900">
				<div class="my-3 mx-3">
					Anni di rinnovo
					<v-btn small @click="selezionaTuttiAnniRinnovo()" class="ml-2 !bg-csenBlue-900 dark:!bg-csenGreen-500 !text-white !tracking-wide">
						Seleziona tutti
					</v-btn>
					<v-btn small @click="deselezionaTuttiAnniRinnovo()" class="ml-2 !bg-csenBlue-900 dark:!bg-csenGreen-500 !text-white !tracking-wide">
						Deseleziona tutti
					</v-btn>
				</div>
				<v-select
					row class="mx-4"
					v-model="filtri.anniRinnovo"
					:items="anniRinnovoDisponibili"
					multiple
					chips
					outlined
					dense
				></v-select>
			</v-sheet>
			<v-sheet v-if="loggedAs && loggedAs.ruolo=='admin'" outlined rounded class="mb-3 dark:!bg-csenBlue-900">
				<div class="my-3 mx-3">
					Anni di rinnovo mancanti
					<v-btn small @click="selezionaTuttiAnniRinnovoMancanti()" class="ml-2 !bg-csenBlue-900 dark:!bg-csenGreen-500 !text-white !tracking-wide">
						Seleziona tutti
					</v-btn>
					<v-btn small @click="deselezionaTuttiAnniRinnovoMancanti()" class="ml-2 !bg-csenBlue-900 dark:!bg-csenGreen-500 !text-white !tracking-wide">
						Deseleziona tutti
					</v-btn>
				</div>
				<v-select
					row class="mx-4"
					v-model="filtri.anniRinnovoMancanti"
					:items="anniRinnovoDisponibili"
					multiple
					chips
					outlined
					dense
				></v-select>
			</v-sheet>

			<v-sheet v-if="loggedAs && loggedAs.ruolo=='admin'" outlined rounded class="mb-3 dark:!bg-csenBlue-900">
				<div class="my-3 mx-3">
					Referenti con gestione autonoma
					<v-btn small @click="selezionaTuttiReferentiAutonomi()" class="ml-2 !bg-csenBlue-900 dark:!bg-csenGreen-500 !text-white !tracking-wide">
						Seleziona tutti
					</v-btn>
					<v-btn small @click="deselezionaTuttiReferentiAutonomi()" class="ml-2 !bg-csenBlue-900 dark:!bg-csenGreen-500 !text-white !tracking-wide">
						Deseleziona tutti
					</v-btn>
				</div>
				<v-select
					row class="mx-4"
					v-model="filtri.referentiIds"
					:items="referentiAutonomi"
					item-value="id"
					item-text="nome"
					multiple
					outlined
					dense
					chips
				></v-select>
			</v-sheet>

			<v-sheet v-if="loggedAs && loggedAs.ruolo=='admin'" outlined rounded class="mb-3 dark:!bg-csenBlue-900">
				<div class="my-3 mx-3">
					Referenti senza gestione autonoma e Nessun Referente
					<v-btn small @click="selezionaTuttiReferentiNoAutonomi()" class="ml-2 !bg-csenBlue-900 dark:!bg-csenGreen-500 !text-white !tracking-wide">
						Seleziona tutti
					</v-btn>
					<v-btn small @click="deselezionaTuttiReferentiNoAutonomi()" class="ml-2 !bg-csenBlue-900 dark:!bg-csenGreen-500 !text-white !tracking-wide">
						Deseleziona tutti
					</v-btn>
				</div>
				<v-select
					row class="mx-4"
					v-model="filtri.referentiIds"
					:items="referentiNoAutonomi"
					item-value="id"
					item-text="nome"
					multiple
					outlined
					dense
					chips
				></v-select>
			</v-sheet>

		</v-card-text>
	</v-card>

	<!--  ${this.$vuetify.theme.isDark ? '#393939' : '#e0e0e0'} !important; -->
	<v-sheet 
		title 
		:style="`position:sticky; bottom:0;`" 
		class="d-flex justify-space-between pa-4 !bg-gray-200 dark:!bg-csenBlue-800"
	>
		<div><v-btn @click="resetFiltri()" class="!bg-csenRed-700 !text-white !tracking-wide">Azzera tutti i filtri</v-btn></div>
		<div>
		<v-btn @click="resetFiltri()" class="!hidden md:!inline-flex !text-csenBlue-900 dark:!text-csenBlue-200 !bg-transparent !tracking-wide">Annulla</v-btn>
		<v-btn @click="applicaFiltri()" class="!bg-csenBlue-900 dark:!bg-csenGreen-500 !text-white !tracking-wide">Filtra</v-btn></div>
	</v-sheet>

	<!-- <div :style="`position:sticky; bottom:0; height:64px; background-color:${themeBackgroundColor}`"></div> -->

	</div>
</template>

<script>
	const datiIniziali = { // Tutti i dati di cui è necessario fare il reset
		filtri: {
			nome: null,
			cognome: null,

			comuniSelezionati: [], // array che contiene i comuni selezionati (gestito dalla treeview)
			diplomiSelezionatiKeys: [], // Contiene le chiavi dei diplomi (hanno la forma: {tipo_id}, ad esempio edizionecorso_2 oppure corso_3)

			tipoFiltroDiplomi: 'or', // "or" oppure "and"

			dataDal: null,
			dataAl: null,

			tipoContatto: null,

			anniRinnovo: [],
			anniRinnovoMancanti: [],

			referentiIds: [],
		},

		localitaSearch: null,
		localitaAperte: [],

		diplomaSearch: null,
		diplomiAperti: [],

		menuDataDal: null,
		menuDataAl: null,
	}

	// const initialData = () => ({
	// 	// env: 'production',

	// 	nome: null,
	// 	cognome: null,

	// 	searchPlaces: '',
	// 	selectedPlaces: [],
	// 	placesOpened: [],
	// 	places: [ // treeview
	// 		{
	// 			id: 0,
	// 			name: 'Italia',
	// 			children: [],
	// 		},
	// 	],

	// 	diplomaSearch: '',
	// 	selectedGraduationsIds: [],
	// 	diplomiAperti: [],
	// 	graduations: [
	// 		{
	// 			id: 0,
	// 			name: 'Tutti i diplomi',
	// 			children: [],
	// 		},
	// 	],
	// 	typeOfGraduationsFilter: 'at_least_one',

	// 	fromDateMenu: false,
	// 	fromDate: null,
	// 	toDateMenu: false,
	// 	toDate: null,

	// 	typeOfContactFilter: 'all',
	// })

	import mixin from '../mixin';
		export default {
			mixins: [mixin],
			// props: ['technician'],
			data() {
				// Il seguente evita di passare i riferimenti per l'oggetto annidato 'datiIniziali.filtri'
				let datiInizialiCopia = JSON.parse(JSON.stringify(datiIniziali));
				return { // I datiIniziali vengono reimpostati con la funzione reset()
					...datiInizialiCopia,
					localita: [ // treeview (inserito qui e non in datiIniziali perché viene riempito un'unica volta)
						{
							name: 'Tutte le province',
							children: [],
						},
					],
					diplomi: [ // treeview (inserito qui e non in datiIniziali perché viene riempito un'unica volta)
						{
							key: 'generic',
							name: 'Tutti i diplomi',
							children: [],
						},
					],
					treeviewDiplomiKey: 0,

					anniRinnovoDisponibili: [],
					referenti: [],
					referentiAutonomi: [],
					referentiNoAutonomi: [],
				}
				// return initialData();
			},
			watch: {
				loggedAs: { // Se cambia il Login, ottieni di nuovo i diplomi per avere la view aggiornata
					handler(){
						this.getDiplomiDisponibili()
					},
					deep: true
				},

				'filtri.diplomiSelezionatiKeys': {
					handler(){
						console.log("aaaa");
						console.log(JSON.stringify(this.filtri.diplomiSelezionatiKeys));
					},
					
				}
			},
			computed: {
				computedDataDalFormattata: {
					get() {
						return this.formattaData(this.filtri.dataDal);
					},
					set(value) {
						this.filtri.dataDal = value;
					}
				},
				computedDataAlFormattata: {
					get() {
						return this.formattaData(this.filtri.dataAl);
					},
					set(value) {
						this.filtri.dataAl = value;
					}
				},
				isDateDiplomiDisabled() {
					if (this.filtri.diplomiSelezionatiKeys.length === 0 || this.filtri.diplomiSelezionatiKeys === null)
						return true;
					
					return false;
				},
				themeBackgroundColor() {
					if (this.$vuetify.theme.isDark) {
						return '##1e1e1e';
					}
					else {
						return '#fff'
					}
				},

			},
			mounted() {
				this.getProvinceComuni();
				this.getDiplomiDisponibili();

				// Il seguente l'ho spostato in funzione apposita chiamata dall'esterno
				// if(this.loggedAs && this.loggedAs.ruolo == 'admin'){
				// 	this.getAnniRinnovoDisponibili();
				// 	this.getReferenti();
				// }
			},
			methods: {
				getNumFiltriAttivi(){
					let numFiltriAttivi = 0;

					// Controlla se il valore di ogni chiave coincide tra i filtri nuovi e quelli originali
					for (let chiave of Object.keys(this.filtri)) {
						if (this.filtri[chiave] !== datiIniziali.filtri[chiave]) {
							if( (this.filtri[chiave] == null && datiIniziali.filtri[chiave] == '') || 
									(this.filtri[chiave] == '' && datiIniziali.filtri[chiave] == null)){
								// Non fare nulla
							} else {
								if(this.filtri[chiave].constructor === Array){
									// Sarà un array anche l'originale:
									if(this.filtri[chiave].length != datiIniziali.filtri[chiave])
										numFiltriAttivi++;
								} else {

									numFiltriAttivi++;
								}
							}
						}
					}

					return numFiltriAttivi;
				},
				applicaFiltri() {
					let numFiltriAttivi = this.getNumFiltriAttivi();

					this.$emit('applica-filtri', this.filtri, numFiltriAttivi);
					this.chiudiDialogFiltri();
				},
				resetFiltri() {
					console.log("in resetFiltri")
					const data = JSON.parse(JSON.stringify(datiIniziali));

					Object.keys(data).forEach(k => {
						this[k] = data[k]
					});
					this.applicaFiltri();
					//this.$emit('applica-filtri', null);
				},
				chiudiDialogFiltri() {
					this.$emit('close-dialog');
				},
				getProvinceComuni() {
					axios.get('/province_comuni')
						.then(res => {
							this.localita[0].children = res.data.map((provincia) => {
								return {
									name: provincia.nome,
									children: provincia.comuni.map((comune) => {
										return {
											name: comune.nome
										}
									})
								}
							})
						})

					// return axios.get('/all/small/reverse')
					// .then(res => {
					// 	// console.log(res.data);
					// 	this.localita[0].children = res.data.map(regione => ({
					// 		id: regione.id,
					// 		name: regione.nome,
					// 		children: regione.province.map(provincia => ({
					// 			id: provincia.sigla,
					// 			name: provincia.nome,
					// 			children: provincia.comuni.map(comune => ({
					// 				id: comune.nome,
					// 				name: comune.nome
					// 			}))
					// 		}))
					// 	}))
					// })
				},
				getDiplomiDisponibili() {
					return axios.get('/diplomi_gerarchia')
					.then(res => {
						this.diplomi[0].children = res.data.map((categoria) => {
							return {
								key: "categoria_" + categoria.id,
								name: categoria.nome,
								children: categoria.corsi.map((corso)=>{
									let obj = {};
									obj.key = 'corso_' + corso.id;
									obj.name = corso.nome;
									
										if(corso.edizioni_corsi.length > 0){ 
											// I tecnici non possono filtrare mai sulle edizioni:
											if(this.loggedAs && this.loggedAs.ruolo == 'admin'){

												// Imposto i children solo se esiste almeno un'edizione, altrimenti NO (così da avere corsi esterni (no edizioni) come finali)
												obj.children = []; // di base li nascondo conservandoli in un altro array, poi se serve li mostro
												obj.edizioniDisponibili = corso.edizioni_corsi.map(edizioneCorso => {
													return {
														key: "edizionecorso_" + edizioneCorso.id,
														name: edizioneCorso.nome
														// Questo è finale quindi non avrà mai children
													}
												})
												obj.hasEdizioni = true;
												obj.isEdizioniMostrate = false;

											} else { // Se però il corso aveva delle edizioni, rinomino la key poi inviata al BE
												obj.key = 'corso-edizioni-nascoste_' + corso.id;
											}
										}

									return obj;
								})
							}
						})

						// // console.log(res.data);
						// this.graduations[0].children = res.data.map(categoria => ({
						// 	id: categoria.Nome,
						// 	name: categoria.Nome,
						// 	children: categoria.corsi.map(corso => ({
						// 		id: corso.idCorso,
						// 		name: corso.Nome,
						// 	}))
						// }))
					})
				},

				mostraEdizioniCorso(item){
					item.children = JSON.parse(JSON.stringify(item.edizioniDisponibili));
					item.isEdizioniMostrate = true;
				},
				nascondiEdizioniCorso(item){
					item.children = [];
					// Ripulisci le possibili edizioni probabilmente SELEZIONATE di questo corso (se esistono)
					let elementiSelezionatiCorretti = JSON.parse(JSON.stringify(this.filtri.diplomiSelezionatiKeys));

					if(item.edizioniDisponibili && item.edizioniDisponibili.length > 0){
						let edizioniDelCorso = JSON.parse(JSON.stringify(item.edizioniDisponibili))
						edizioniDelCorso.forEach(el => {
							// Se lo trovo tra quelli selezionati, lo rimuovo
							let idx = elementiSelezionatiCorretti.indexOf(el.key);
							if (idx !== -1) {
								elementiSelezionatiCorretti.splice(idx, 1);
							}
						});
						// this.filtri.diplomiSelezionatiKeys = JSON.parse(JSON.stringify(elementiSelezionatiCorretti));
						
						this.$set(this.filtri, 'diplomiSelezionatiKeys', elementiSelezionatiCorretti);
						
						this.treeviewDiplomiKey++;
					}

					item.isEdizioniMostrate = false;
				},

				controllaIsAdmin(){
					// Se ho aperto la dialog come admin, allora prendo anche anniDisponibili e Referenti
					if(this.loggedAs && this.loggedAs.ruolo == 'admin'){
						if(this.anniRinnovoDisponibili.length == 0)
							this.getAnniRinnovoDisponibili();
						if(this.referenti.length == 0)
							this.getReferenti();
					}
				},
				getAnniRinnovoDisponibili(){
					axios.get('/anni_rinnovo')
						.then(res => {
							this.anniRinnovoDisponibili = res.data;
						})
				},
				getReferenti(){
					axios.get('/referenti')
						.then(res => {
							this.referenti = res.data;

							// Nei referenti senza gestione autonoma aggiungo anche la voce 'nessun referente':
							this.referentiNoAutonomi.push({
								id: -1,
								nome: 'Nessun Referente',
								autogestisce_rinnovi: 0
							})

							this.referenti.forEach(el=>{
								if(el.autogestisce_rinnovi == 1){
									this.referentiAutonomi.push(JSON.parse(JSON.stringify(el)));
								} else {
									this.referentiNoAutonomi.push(JSON.parse(JSON.stringify(el)));
								}
							})

						})
				},

				selezionaTuttiReferentiAutonomi(){
					this.referentiAutonomi.forEach(ref => {
						if(!this.filtri.referentiIds.includes(ref.id))
							this.filtri.referentiIds.push(ref.id)
					})
				},
				selezionaTuttiReferentiNoAutonomi(){
					this.referentiNoAutonomi.forEach(ref => {
						if(!this.filtri.referentiIds.includes(ref.id))
							this.filtri.referentiIds.push(ref.id)
					})
				},

				deselezionaTuttiReferentiAutonomi(){
					// Mantiene solo quelli che non sono presenti dei referenti autonomi
					this.filtri.referentiIds = this.filtri.referentiIds.filter(refId => {
						let trovato = false;
						this.referentiAutonomi.some(refAuto => {
							if(refAuto.id == refId){
								trovato = true;
								return true;
							}
						})
						return !trovato; // Se li trovo devo restituire null perché devo escluderli!
					})
				},
				deselezionaTuttiReferentiNoAutonomi(){
					// Mantiene solo quelli che non sono presenti dei referenti autonomi
					this.filtri.referentiIds = this.filtri.referentiIds.filter(refId => {
						let trovato = false;
						this.referentiNoAutonomi.some(refAuto => {
							if(refAuto.id == refId){
								trovato = true;
								return true;
							}
						})
						return !trovato; // Se li trovo devo restituire null perché devo escluderli!
					})
				},

				selezionaTuttiAnniRinnovo(){
					this.anniRinnovoDisponibili.forEach(anno => {
						if(!this.filtri.anniRinnovo.includes(anno))
							this.filtri.anniRinnovo.push(anno)
					})
				},
				selezionaTuttiAnniRinnovoMancanti(){
					this.anniRinnovoDisponibili.forEach(anno => {
						if(!this.filtri.anniRinnovoMancanti.includes(anno))
							this.filtri.anniRinnovoMancanti.push(anno)
					})
				},
				deselezionaTuttiAnniRinnovo(){
					// Mantiene solo quelli che non sono presenti dei referenti autonomi
					this.filtri.anniRinnovo = this.filtri.anniRinnovo.filter(anno => {
						let trovato = false;
						this.anniRinnovoDisponibili.some(annoAuto => {
							if(annoAuto == anno){
								trovato = true;
								return true;
							}
						})
						return !trovato; // Se li trovo devo restituire null perché devo escluderli!
					})
				},
				deselezionaTuttiAnniRinnovoMancanti(){
					// Mantiene solo quelli che non sono presenti dei referenti autonomi
					this.filtri.anniRinnovoMancanti = this.filtri.anniRinnovoMancanti.filter(anno => {
						let trovato = false;
						this.anniRinnovoDisponibili.some(annoAuto => {
							if(annoAuto == anno){
								trovato = true;
								return true;
							}
						})
						return !trovato; // Se li trovo devo restituire null perché devo escluderli!
					})
				},

				espandiTutteLocalita() {
					if (this.localitaSearch) {
						this.localitaAperte = this.treeviewOttieniKeysPerEspandereTutto(this.localita, 'name');
					}
					// else { // Per ora lasciati aperti
					// 	this.localitaAperte = []; // Resetta se non c'è nessuna ricerca
					// }
				},
				espandiTuttiDiplomi() {
					if (this.diplomaSearch) {
						this.diplomiAperti = this.treeviewOttieniKeysPerEspandereTutto(this.diplomi, 'key');
					}
					// else { // Per ora lasciati aperti
					// 	this.diplomiAperti = []; // Resetta se non c'è nessuna ricerca
					// }
				},
				treeviewOttieniKeysPerEspandereTutto(items, nameOrKey){
					const allKeys = [];

					// Funzione ricorsiva per ottenere tutti i `item-key`
					const recursiveExpand = (nodes) => {
						nodes.forEach(node => {
							if(nameOrKey == 'name')
								allKeys.push(node.name); // Usa il valore del tuo item-key
							else
								allKeys.push(node.key); // Usa il valore del tuo item-key
							if (node.children && node.children.length > 0) {
								recursiveExpand(node.children);
							}
						});
					};

					recursiveExpand(items);

					return allKeys;
				},
			},
		}
</script>

<style lang="scss" scoped></style>